import JSONObject from "@ltypes/commons/jsonObject";
import { Scene } from "@ltypes/scene";
import Group from "@ltypes/group";
import AbstractApiService from "./AbstractApiService";

export default class ProductService extends AbstractApiService {
    pair = (code: string): Promise<any> => {
        return this.call('POST', '/products/pair', JSON.stringify({
            code,
        }));
    };

    unpair = (id: string): Promise<any> => {
        return this.call('POST', '/products/' + id + '/unpair');
    };

    get = (id: string): Promise<any> => {
        return this.call('GET', '/products/' + id);
    };

    update = (id: string, json: JSONObject): Promise<any> => {
        return this.call('PATCH', '/products/' + id, JSON.stringify(json));
    };

    updateScene = (id: string, scene: Scene): Promise<any> => {
        return this.call('PATCH', '/products/' + id + '/scenes/' + scene.id, JSON.stringify(scene));
    };

    createScene = (id: string, groupId: string, type: number): Promise<any> => {
        return this.call('POST', '/products/' + id + '/groups/' + groupId + '/scenes', JSON.stringify({
            type: type,
        }));
    };

    syncScenes = (id: string, groupId: string, scenes: Array<{ id: string, enabled: boolean }>): Promise<any> => {
        return this.call('PATCH', '/products/' + id + '/groups/' + groupId + '/scenes/sync', JSON.stringify({
            scenes: scenes,
        }));
    };

    createSceneFlash = (id: string, formData: {[label: string]: any}): Promise<any> => {
        return this.call('POST', '/products/' + id + '/flash', JSON.stringify(formData));
    };

    deleteSceneFlash = (id: string): Promise<any> => {
        return this.call('DELETE', '/products/' + id + '/flash');
    };

    deleteScene = (id: string, sceneId: string): Promise<any> => {
        return this.call('DELETE', '/products/' + id + '/scenes/' + sceneId);
    };

    createGroup = (id: string, name: string, color: number, allDay: boolean, startTime: string, stopTime: string, repeat: Array<number>): Promise<any> => {
        return this.call('POST', '/products/' + id + '/groups', JSON.stringify({
            name: name,
            color: color,
            all_day: allDay,
            start_time: startTime,
            stop_time: stopTime,
            repeat: repeat,
        }));
    };

    updateGroup = (id: string, group: Group): Promise<any> => {
        return this.call('PATCH', '/products/' + id + '/groups/' + group.id, JSON.stringify(group));
    };

    deleteGroup = (id: string, groupId: string): Promise<any> => {
        return this.call('DELETE', '/products/' + id + '/groups/' + groupId);
    };

    updateFirmware = (id: string): Promise<any> => {
        return this.call('POST', '/products/' + id + '/update');
    };

    listVersions = (): Promise<any> => {
        return this.call('GET', '/products/versions');
    };
}
